import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '../core/broadcaster/broadcaster.service';

@Injectable()
export class ThingModalEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(key: string, thing: any): void {
    this.broadcaster.broadcast(ThingModalEvent, {
      key: key,
      thing: thing
    });
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(ThingModalEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/ThingModalEvent.ts